import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { sportsMenuFullQuery } from '@/api/queries';
import { resolveSport } from '@/shell/sports-menu-utils';
import { EmptyState, HomeTopEvents, Skeleton } from '@/ui';
import { LastMinuteSection } from './-components/LastMinuteSection';
import { LiveSection } from './-components/LiveSection';

export const Route = createFileRoute('/sports/$sport/')({
  component: SportLandingPage,
});

function SportLandingPage() {
  const { sport: sportSlug } = Route.useParams();
  const { t } = useTranslation();
  const menuQuery = useQuery(sportsMenuFullQuery());

  const sport = useMemo(
    () => resolveSport(menuQuery.data, sportSlug),
    [menuQuery.data, sportSlug],
  );

  if (menuQuery.isPending) {
    return (
      <div className="flex flex-col gap-4" aria-busy="true">
        <Skeleton kind="line" className="h-5 w-28" />
        <Skeleton kind="block" className="h-48 w-full rounded-md" />
      </div>
    );
  }

  if (!sport) {
    return (
      <EmptyState
        icon="football"
        title={t('SportNotFound', { defaultValue: 'Sport not found' })}
        description={t('SportNotInMenu', {
          defaultValue: 'This sport is not in the current sports menu.',
        })}
      />
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <HomeTopEvents sport={sport.Name} includeAccountEventIds={false} />
      <LiveSection sportSlug={sportSlug} sportName={sport.Name} />
      <LastMinuteSection sportSlug={sportSlug} sportName={sport.Name} />
    </div>
  );
}
